import { scrollToChangedElement } from '../../../shared/hooks/useUnsavedChanges';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { useAdminExhibitionStore } from '../../share/store/adminExhibitionStore';

export const runAfterUnsavedExhibitionCheck = (action: () => void) => {
  if (!useAdminExhibitionStore.getState().hasChanged) {
    action();
    return;
  }

  setTimeout(scrollToChangedElement, 100);
  useStandardAlertStore.getState().setUnchangedAlert(action);
};

export const runAfterExhibitionListContextChange = (action: () => void) => {
  if (useAdminExhibitionStore.getState().multiSelectedExhibitionIds.length < 2) {
    action();
    return;
  }

  runAfterUnsavedExhibitionCheck(() => {
    useAdminExhibitionStore.getState().clearExhibitionSelection();
    action();
  });
};
